import { useEffect, useState } from "react";
import getMappingManager, { sanitizeMapping } from "./mappingManager";
import MappingRow from "./MappingRow";
import TranslationsContext from './TranslationsContext';
import Translate, {__, TranslateHTML} from "./Translate";
function App({ mappingInit, i18n, fields, defaultMappingOptions, featuresByPostType, config }) {

	const [ mapping, setMapping ] = useState(sanitizeMapping(mappingInit, fields));
	const mappingManager = getMappingManager({ mapping, setMapping, fields, defaultMappingOptions, featuresByPostType, config });
	const { addMappingRow } = mappingManager;
	const addMappingRowHandler = () => {
		addMappingRow();
	};

	useEffect(() => {
		const event = new CustomEvent('notionwpsync/mapping-updated', { detail: mapping } );
		document.dispatchEvent(event);
	}, [ mapping ]);

	return <TranslationsContext.Provider value={ i18n }>
		<table className="form-table">
			<thead>
				<tr>
					<th>
						<span>{ __('Notion Field', 'wp-sync-for-notion') }</span>
						<span className="notionwpsync-required" aria-hidden="true"> *</span>
						<span className="screen-reader-text">{ __(' (required)', 'wp-sync-for-notion') }</span>
					</th>
					<th>
						<span>{ __('Import As', 'wp-sync-for-notion') }</span>
						<span className="notionwpsync-required" aria-hidden="true"> *</span>
						<span className="screen-reader-text">{ __(' (required)', 'wp-sync-for-notion') }</span>
					</th>
					<th className="col-actions"></th>
				</tr>
			</thead>
			<tbody key="metabox-mapping-body">
				{
					mapping.length > 0
						? mapping.map((mappingRow, index) => <MappingRow key={ index } index={ index } notionField={ mappingRow.notion } wordPressField={ mappingRow.wordpress } fieldOptions={ mappingRow.options } mappingManager={ mappingManager } />)
						: <tr>
							<td colSpan="3">
								<TranslateHTML
									className="no-mapping"
									string={ __('Click the <strong>+ Add Field</strong> button to create your first field.', 'wp-sync-for-notion') }
									allowedHTMLTags={[ 'strong' ]}
								/>
							</td>
						</tr>
				}
			</tbody>
			<tfoot key="metabox-mapping-footer">
				<tr>
					<td colSpan="3">
						<button type="button" className="button button-primary button-large" onClick={ addMappingRowHandler }>
							<span>{ __('+ Add Field', 'wp-sync-for-notion') }</span>
						</button>
					</td>
				</tr>
			</tfoot>
		</table>
	</TranslationsContext.Provider>;
}

export default App;
